import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import essential_oil from '../images/home_image/Essential_Oils.jpg';
import essential_oil_2 from '../images/home_image/Essential_Oils_2.jpg';
import essential_oil_3 from '../images/home_image/Essential_Oils_3.jpg';

import factory_1 from '../images/store_image/factory_1.jpeg';
import factory_2 from '../images/store_image/factory_2.jpeg';
import factory_3 from '../images/store_image/factory_3.jpeg';
import factory_4 from '../images/store_image/factory_4.jpeg';
import factory_5 from '../images/store_image/factory_5.jpeg';
import factory_6 from '../images/store_image/factory_6.jpeg';
import factory_7 from '../images/store_image/factory_7.jpeg';
import factory_8 from '../images/store_image/factory_8.jpeg';
import factory_9 from '../images/store_image/factory_9.jpeg';
import factory_10 from '../images/store_image/factory_10.jpeg';
import factory_11 from '../images/store_image/factory_11.jpeg';
import factory_12 from '../images/store_image/factory_12.jpeg';

export default function Home() {
  const banners = [essential_oil, essential_oil_2, essential_oil_3];
  const [currentBanner, setCurrentBanner] = useState(0);

  useEffect(() => {
    const timer = setInterval(
      () => setCurrentBanner(i => (i + 1) % banners.length),
      4500
    );
    return () => clearInterval(timer);
  }, []);

  const colors = {
    green: '#4a7c59',
    beige: '#f4f1ea',
    textDark: '#333333',
    textLight: '#ffffff',
  };

  const factoryImages = [
    factory_1, factory_2, factory_3, factory_4, factory_5, factory_6,
    factory_7, factory_8, factory_9, factory_10, factory_11, factory_12
  ];

  const marqueeStyle = `
    @keyframes scrollLeft {
      0% { transform: translateX(0); }
      100% { transform: translateX(-50%); }
    }
    .factory-scroll-track:hover {
      animation-play-state: paused;
    }
  `;

  return (
    <div className="home-wrapper" style={{ width: '100%', overflowX: 'hidden' }}>

      {/* ── HERO ── */}
      <div style={{ position: 'relative', height: '90vh', width: '100%', overflow: 'hidden' }}>
        <img
          src={banners[currentBanner]}
          alt="Aromora banner"
          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
        />
        <div style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.35)' }} />

        <div
          className="container"
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            textAlign: 'center',
            color: '#fff',
            width: '90%'
          }}
        >
          <h1 style={{ fontSize: '3.5rem', fontWeight: 800, marginBottom: '1rem' }}>
            Aromora Naturals
          </h1>

          <p style={{ fontSize: '1.5rem', maxWidth: 900, margin: '0 auto 2rem', lineHeight: 1.4 }}>
            Purity, flavor, and aroma from the heart of India — premium spices,
            essential oils, and natural extracts.
            <br />
            <span style={{ fontSize: '1.2rem', opacity: 0.9 }}>
              Trusted sourcing. International quality. Sustainable practices.
            </span>
          </p>

          <div style={{ display: 'flex', gap: 20, justifyContent: 'center' }}>
            <Link to="/about" className="btn" style={{ background: colors.green }}>
              Our History
            </Link>
            <Link to="/natural" className="btn secondary">
              View Products
            </Link>
          </div>
        </div>
      </div>

      {/* ── WHO WE ARE ── */}
      <section style={{ backgroundColor: colors.green, padding: '80px 0', color: '#fff' }}>
        <div className="container" style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
          <div style={{ flex: '1 1 500px', paddingRight: 40 }}>
            <h2 style={{ fontSize: '3rem', marginBottom: 20 }}>We Are Aromora</h2>
            <p style={{ fontSize: '1.2rem', lineHeight: 1.6 }}>
              Since 1960, our family has been the "nose" behind some of the world’s most captivating scents.
              Formerly known as Royal Perfumers & Fragrances, our new identity, Aromora Naturals,
              reflects our commitment to the Earth and our customers.
            </p>
          </div>

          <div style={{ flex: '1 1 400px' }}>
            <img
              src={essential_oil_2}
              alt="About Aromora"
              style={{ width: '100%', borderRadius: 6 }}
            />
          </div>
        </div>
      </section>

      {/* ── SERVICES ── */}
      <section style={{ backgroundColor: colors.beige, padding: '80px 0' }}>
        <div className="container" style={{ display: 'flex', flexWrap: 'wrap-reverse', alignItems: 'center' }}>
          <div style={{ flex: '1 1 400px' }}>
            <img
              src={essential_oil_3}
              alt="Services"
              style={{ width: '100%', borderRadius: 6 }}
            />
          </div>

          <div style={{ flex: '1 1 500px', paddingLeft: 40 }}>
            <h2 style={{ fontSize: '3rem', color: colors.green }}>Our Core Products</h2>

            <p style={{ fontSize: '1.1rem', lineHeight: 1.6 }}>
              We offer a wide range of whole and ground Indian spices, 100% natural
              essential oils, and carefully processed dehydrated vegetables —
              all sourced directly from trusted farms and distilleries across India.
            </p>

            <Link to="/natural" style={{ color: colors.green, fontWeight: 700 }}>
              Explore Products →
            </Link>
          </div>
        </div>
      </section>

      {/* ── WHY CHOOSE US ── */}
      <section style={{ backgroundColor: colors.green, padding: '80px 0', color: '#fff' }}>
        <div className="container">
          <h2 style={{ fontSize: '2.5rem', marginBottom: 40 }}>Why Choose Aromora Naturals?</h2>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px,1fr))', gap: 40 }}>
            <div>
              <h3>Direct Sourcing</h3>
              <p>100% natural, non-GMO ingredients sourced directly from Indian farmers.</p>
            </div>
            <div>
              <h3>Quality & Safety</h3>
              <p>Embedded food safety systems with consistent quality checks.</p>
            </div>
            <div>
              <h3>Sustainability</h3>
              <p>Ethical practices, custom blends, and private label solutions.</p>
            </div>
          </div>
        </div>
      </section>

      {/* ── FACTORY GLIMPSE (IMPROVED) ── */}
<style>{`
@keyframes smoothScroll {
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
}

.factory-marquee {
  position: relative;
  overflow: hidden;
}

.factory-track {
  display: flex;
  gap: 28px;
  width: max-content;
  animation: smoothScroll 40s linear infinite;
}

.factory-marquee:hover .factory-track {
  animation-play-state: paused;
}

/* fade edges */
.factory-marquee::before,
.factory-marquee::after {
  content: "";
  position: absolute;
  top: 0;
  width: 120px;
  height: 100%;
  z-index: 2;
  pointer-events: none;
}

.factory-marquee::before {
  left: 0;
  background: linear-gradient(to right, #f4f1ea 0%, transparent 100%);
}

.factory-marquee::after {
  right: 0;
  background: linear-gradient(to left, #f4f1ea 0%, transparent 100%);
}
`}</style>

<section style={{ backgroundColor: colors.beige, padding: '80px 0' }}>
  <div className="container" style={{ textAlign: 'center', marginBottom: 40 }}>
    <h2 style={{ fontSize: '2.5rem', color: colors.green }}>
      Inside Our Facility
    </h2>
    <p>State-of-the-art processing meets traditional purity.</p>
  </div>

  <div className="factory-marquee">
    <div className="factory-track">
      {[...factoryImages, ...factoryImages].map((img, i) => (
        <div
          key={i}
          style={{
            width: 320,
            height: 220,
            borderRadius: 16,
            overflow: 'hidden',
            boxShadow: '0 12px 30px rgba(0,0,0,0.12)',
            background: '#fff'
          }}
        >
          <img
            src={img}
            alt="Factory"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              transition: 'transform 0.6s ease'
            }}
          />
        </div>
      ))}
    </div>
  </div>
</section>

      {/* ── BOTTOM CTA ── */}
      <section style={{ backgroundColor: '#fff', padding: '80px 0', textAlign: 'center' }}>
        <div className="container">
          <h2 style={{ fontSize: '2.5rem' }}>Let’s Work Together</h2>
          <p style={{ maxWidth: 600, margin: '20px auto' }}>
            Serving India and global markets with integrity, consistency, and care.
          </p>
          <Link to="/contact" className="btn">
            Contact Us
          </Link>
        </div>
      </section>

    </div>
  );
}
